import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from 'ngx-clipboard';
import { ProcessComponent } from './process/process.component';
import { TableComponent } from './table.component';
@NgModule({
	imports: [
		CommonModule,
		MatTooltipModule,
		MatMenuModule,
		MatSortModule,
		MatTableModule,
		MatIconModule,
		MatButtonModule,
		ClipboardModule,
		MatSelectModule,
		MatDividerModule,
		MatCheckboxModule,
		MatRippleModule
	],
	exports: [TableComponent],
	declarations: [TableComponent, ProcessComponent]
})
export class TableModule {}
